var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentHubLink24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.36 47.79",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.19,23.86h0a22,22,0,0,0-22-22H55.27a4,4,0,0,0,0,8.06h8.91a14,14,0,0,1,14,14h0a14,14,0,0,1-14,14H55.3a4,4,0,1,0,0,8.06h8.91a22,22,0,0,0,22-22Z",
    fill: "#828385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27,39.47a21.91,21.91,0,0,0,15.49,6.42H34.94a4,4,0,0,0,0-8.06h-11A14,14,0,0,1,23.81,9.9h11a4,4,0,0,0,.07-8h-11A22,22,0,0,0,8.27,39.47Z",
    fill: "#828385"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4,23.9a4,4,0,0,0,4,4h.06l33.23,0a4,4,0,1,0,0-8.06l-33.24,0a4,4,0,0,0-4,4Z",
    fill: "#828385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentHubLink24Px);
export default __webpack_public_path__ + "static/media/content-hub-link-24px.bef42ac9547e22fc1f49daa58eafee8e.svg";
export { ForwardRef as ReactComponent };